// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-map-items-async-request-schema',
  type: 'object',
  required: ['eventIdentifier'],
  properties: {
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
    categoryId: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
  },
} as IJSONSchema;

export default schema;
